import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, AlertCircle } from "lucide-react";

const VerificationStep = ({
  number,
  text,
}: {
  number: number;
  text: string;
}) => (
  <div className="flex items-start space-x-3">
    <div className="flex-shrink-0 w-6 h-6 bg-nation-purple text-white rounded-full flex items-center justify-center text-sm">
      {number}
    </div>
    <p className="text-gray-700 dark:text-gray-300">{text}</p>
  </div>
);

const HowToVerify = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl text-nation-blue dark:text-blue-300">
          How to Become a Verified Pollster
        </CardTitle>
        <p className="text-gray-600 dark:text-gray-400">
          Get verified in 4 simple steps! This ensures secure, trustworthy, and
          representative polling for all.
        </p>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          {[
            "Upload an identity document(s) for verification.",
            "Complete your demographic information.",
            "Add your phone number.",
            "Wait for us to review and approve your submission.",
          ].map((step, index) => (
            <VerificationStep key={index} number={index + 1} text={step} />
          ))}
        </div>

        <div className="mt-6 space-y-4">
          <div className="flex items-start space-x-2 text-nation-purple dark:text-purple-300">
            <Check className="h-5 w-5 mt-0.5" />
            <p className="text-sm">
              <span className="font-semibold">Tip:</span> Each step can be
              completed right here in Your Profile tab area.
            </p>
          </div>

          <div className="flex items-start space-x-2 text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg">
            <AlertCircle className="h-5 w-5 mt-0.5" />
            <p className="text-sm">
              <span className="font-semibold">Privacy Note:</span> All your
              information and documents remain confidential and protected.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default HowToVerify;
